import { IPieChartData } from "./IPieChartData";

export const processPieChartData = (data: IPieChartData, labels: Array<string>): Array<Array<any>> => {
    if (!data)
        return [[]];

    var processedData: Array<Array<any>> = [labels];
    data.datasets.forEach((element) => {
        if (element.backgroundColor !== null) {
            let displayText = data.valueFormatter ? data.valueFormatter(element.value.toString()) : element.value;
            if(element.customTooltip != null){
                displayText = " " + element.customTooltip;
            }
            processedData.push([element.label, { v: element.value, f: displayText }]);
        }
    });
    return processedData;
};

export const processPieChartColors = (data: IPieChartData) => {
    if (data == null) return [];
    var colors: Array<string> = [];
    data.datasets.forEach((element) => {
        if (element.backgroundColor !== null) {
            colors.push(element.backgroundColor);
        };
    });
    return colors;
};
